// extracted by mini-css-extract-plugin
export default {"LoadingContainer":"webpack-containers-Extraction-ReuseTemplateModal-module__LoadingContainer"};